import { RoleEmployer } from "./roleEmployer";
export class Employer {
  personnel_id: any = null;
  personnel_adresse: string = "";
  personnel_im: string = "";
  personnel_etat: string = "";
  personnel_nom: string = "";
  personnel_onm: string = "";
  personnel_prenom: string = "";
  personnel_sexe: string = "";
  personnel_tel1: string = "";
  personnel_mot_passe: string = "";
	personnel_logine: string = "";
	personnel_on_line:string = "";
  petit_client_id : string = "";
  localite_id : string ="";
  roleEmployer : RoleEmployer;
  role : Array<RoleEmployer>;
  nombreConsultation : number;

  date_debut : String;
  date_fin : String;
  //occ_id:any = null;

  roles : Array<RoleEmployer>;


  constructor($personnel_id:any){
            this.personnel_id=$personnel_id;           
            this.roleEmployer=new RoleEmployer();
            this.role=new Array<RoleEmployer>();
            this.roles=new Array<RoleEmployer>();
        } 
      
    
   } 